// Utils
import { formatDate } from './Date'
import { PAYMENT_CHANNELS } from '@/models/Payment'

const publicHolidays = [
  '2019-12-25',
  '2019-12-26',
  '2020-01-01',
  '2020-04-10',
  '2020-04-13',
  '2020-05-01',
  '2020-12-25',
  '2020-12-26',
  '2021-01-01'
]

export function getPreviousWorkday (startDate) {
  let date = new Date(new Date(startDate).setDate(startDate.getDate() - 1))

  while (!isWorkday(formatDate(date))) {
    date = new Date(new Date(date).setDate(date.getDate() - 1))
  }

  return formatDate(date)
}

export function getNextWorkday (startDate) {
  let date = new Date(new Date(startDate).setDate(startDate.getDate() + 1))

  while (!isWorkday(formatDate(date))) {
    date = new Date(new Date(date).setDate(date.getDate() + 1))
  }

  return formatDate(date)
}

export function isWorkday (date) {
  const weekend = [6, 0]

  return !publicHolidays.includes(date) && !weekend.includes((new Date(date)).getDay())
}

export function getAvailableProcessingDates (channel) {
  const today = new Date()
  if (channel != null && [PAYMENT_CHANNELS.IFAST].includes(channel)) {
    return Array.from({ length: 4 }, (_, i) => {
      const date = new Date(today)
      date.setDate(today.getDate() - i)
      return formatDate(date)
    })
  }
  if (isWorkday(formatDate(today))) {
    return [formatDate(today), getPreviousWorkday(today)]
  }
  return [getPreviousWorkday(today)]
}

export function getAvailableProcessingDatesForex () {
  const today = new Date()

  if (isWorkday(formatDate(today))) {
    return [formatDate(today), getPreviousWorkday(today)]
  }

  return [getPreviousWorkday(today)]
}
